import { useMutation, useQueryClient } from 'react-query'
import { addPurchase } from 'Services/purchases/purchasesService'
import { QueryNames } from 'Hooks/api/queryNames'
import { ModalActionTypes, useModalContext } from 'Contexts/ModalContext'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'

export const useAddPurchaseQuery = () => {
  const { dispatch } = useModalContext()
  const queryClient = useQueryClient()

  return useMutation([QueryNames.AddPurchase], addPurchase, {
    onSuccess: (response) => {
      if (response.success) {
        dispatch({ type: ModalActionTypes.SetShowAddPurchaseModal, value: false })
        queryClient.invalidateQueries([QueryNames.GetUserPurchases])
        queryClient.invalidateQueries([QueryNames.GetUserOngoingPurchases])
        queryClient.invalidateQueries([QueryNames.GetUserPendingOPRPurchases])
        toast.success(AppNotification.AddPurchaseSuccess)
      } else {
        toast.error(`${AppNotification.AddPurchaseFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.AddPurchaseFailure)
    }
  })
}
